import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import TopNav from '../../components/topnav/topnav';
import Course from '../../components/course/course';
import Footer from '../../components/footer/footer';
import { Layout, Typography, Row, Col, Button, Card, Carousel, message, Icon, Tag } from 'antd';
import { SIGNUP_SUCCESS_MSG } from '../../../../core/constants/constants'
import moment from 'moment';
import ReactGA from 'react-ga';
import Signupcard from '../../components/signup/signupcard';

import { signUp, sendEmailVerification } from './../../../../core/actions/auth';
import { getCourses, getSections, getLastView } from '../../../../core/actions/courseGet';
import { getStudents } from '../../../../core/actions/allUsers';
import { getPosts } from '../../../../core/actions/postGet';
import { bindActionCreators } from "redux"
import { Helmet } from "react-helmet";
import Maintenance from "../maintenance"
import section from '../../components/editcoursecurriculum/section';
import Homeheader from "../../components/home/header"
import Popularcourses from '../../components/home/popularcourses';
import Registration from '../../components/home/registration';
import Instructors from '../../components/home/instructors';
import Testimonials from '../../components/home/feedback';
import Newsblog from '../../components/home/newsblog';
import Bottom from '../../components/home/bottom';
import Dashboard from '../dashboard';
const { Title } = Typography;
const { Content } = Layout;
const { Meta } = Card;

class Home extends Component {
  constructor(props) {
    super(props);

    this.state = {
      courses: [],
      students: []
    };

    this.handleClick = this.handleClick.bind(this);
  }

  componentWillMount() {
    window.scrollTo({ top: 0 });
  }

  componentDidMount() {
    const { courses, students } = this.state;
    const profileUid = localStorage.getItem('uid')
    if (!courses.length) {
      this.props.getCourses();
    }
    if (!students.length) {
      this.props.getStudents();
    }
    if (!this.props.blogPost.length) {
      this.props.getPosts()
    }
    if(!this.props.lastViewCourse.id && profileUid){
      this.props.getLastView(profileUid)
    }
  }
  
  componentWillReceiveProps(nextProps) {
    const { authError, authSuccess, courses, students } = nextProps;
    // if (authError) message.error(authError);
    if (authSuccess === SIGNUP_SUCCESS_MSG) {
      message.success(authSuccess)
      window.fbq('track', 'CompleteRegistration');
      ReactGA.event({
        category: 'User',
        action: 'Complete Registration',
        label: 'User Interaction'
      });
    }
    if (courses.length > 0) {
      courses.sort((a, b) => new Date(b.created) - new Date(a.created))
      this.setState({ courses });
    }
    if (students.length > 0) {
      this.setState({ students });
    }
  }

  handleClick(slug) {
    this.props.history.push(`/courses/${slug}`);
  }

  render() {
    const { courses, students } = this.state;
    const {authError,blogPost, authSuccess} = this.props
    var courseLenght = courses.length < 100 ? courses.length : courses.length -1 + '+'
    var studentLenght = students.length < 100 ? students.length : students.length -1 + '+'
    var mobile = window.innerWidth > 780 ? false : true;
    return (
      <div className="home-page">
        <Helmet>
          <title>Orsity</title>
          <meta name="description" content="Oristy is a group of working web development professionals and open source contributors that provide you with concise, information dense video courses on the best tools in the industry." />
        </Helmet>
        <TopNav history={this.props.history} />
        {!this.props.firebase.auth.uid?
        <div>
        <Homeheader
        auth={this.props.firebase.auth}
        history={this.props.history} 
        />
        {/* <Homecourses /> */}
        {courses.length && <Popularcourses 
        history={this.props.history} 
        courses={courses}
       
        />}
        {!this.props.firebase.auth.uid && <Registration 
        loading={this.props.loading}
         signUp={this.props.signUp}
         authError={authError} 
         courses={courses.length}
         students={students.length}
         blogPost={blogPost.length}
         authSuccess={authSuccess}/>}
        {/* <Instructors /> */}
        <Testimonials />
        {blogPost.length && <Newsblog 
        history={this.props.history} 
        lists={blogPost}/>}
       
          <Bottom 
            firebase={this.props.firebase}
            history={this.props.history} 
            />          

          </div>:
          <Dashboard 
          {...this.props}/>
        }
         <Footer /> 
        
        {/* <Maintenance /> */}
      </div>
    );
  }
}

const mapDispatchToProps = dispatch => bindActionCreators({
  signUp,
  getCourses,
  getStudents,
  getSections,
  getPosts,
  sendEmailVerification,
  getLastView,

}, dispatch);

const mapStateToProps = state => ({
  firebase: state.firebase,
  loading: state.auth.loading,
  authError: state.auth.authError,
  authSuccess: state.auth.authSuccess,
  profile: state.firebase.profile,
  courses: state.getCourses.courses,
  blogPost:state.allPosts.posts,
  students: state.allUsers.students,
  sections: state.getCourses.sections,
  lastViewCourse: state.getCourses.lastViewCourse,
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Home);